module.exports = __webpack_public_path__ + "img/auth-阿虎医考-金牌代理商领奖.1c043e3f.jpg";